import {
  decorate,
  observable,
  action,
  runInAction,
  computed
} from 'mobx'

class AsyncStoreBase {
  constructor () {
    runInAction(() => {
      this.busy = false
      this.error = null
      this.success = null
    })
  }

  setError = (error = null) => {
    runInAction(() => {
      this.error = error
    })
  }

  setSuccess = (result = null) => {
    runInAction(() => {
      this.success = result
    })
  }

  setBusy = (yesno = false) => {
    runInAction(() => {
      this.busy = yesno
    })
  }

  get isBusy () {
    return !!this.busy
  }
}

decorate(AsyncStoreBase, {
  busy: observable,
  error: observable,
  success: observable,

  isBusy: computed,

  setError: action,
  setSuccess: action,
  setBusy: action
})

export default AsyncStoreBase
